/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for activationMode. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="activationMode"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="active"/&gt; &lt;enumeration value="inactive"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class ActivationMode extends Enum{

	enumValue = null;

	static  ACTIVE = ActivationMode.newLiteral("active");

	static  INACTIVE = ActivationMode.newLiteral("inactive");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < ActivationMode.values().length); ++i) {
			if (ActivationMode.values()[i].enumValue == v) {
				return ActivationMode.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("ActivationMode" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/ActivationMode.js